'use strict';

var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Utils$AlgoVis = require("./Utils.bs.js");
var Components$AlgoVis = require("./Components.bs.js");
var LoadBalancing$AlgoVis = require("./LoadBalancing.bs.js");

function Pages$Home(Props) {
  var match = React.useState(function () {
        return /* Greedy */0;
      });
  var setAlgo = match[1];
  var algo = match[0];
  var match$1 = React.useState(function () {
        return 0.5;
      });
  var setEpsilon = match$1[1];
  var epsilon = match$1[0];
  var match$2 = React.useState(function () {
        return 4;
      });
  var setNumMachines = match$2[1];
  var numMachines = match$2[0];
  var match$3 = React.useState(function () {
        return [
                1,
                1,
                2,
                2,
                3,
                4
              ];
      });
  var setJobs = match$3[1];
  var jobs = match$3[0];
  var match$4 = React.useState(function () {
        return jobs.length;
      });
  var setNumJobs = match$4[1];
  var numJobs = match$4[0];
  var match$5 = React.useState(function () {
        
      });
  var setResult = match$5[1];
  var match$6 = React.useState(function () {
        
      });
  var setMakespan = match$6[1];
  var makespan = match$6[0];
  var match$7 = React.useState(function () {
        
      });
  var setRunningTime = match$7[1];
  var runningTime = match$7[0];
  React.useEffect((function () {
          var numJobsInState = jobs.length;
          if (numJobsInState > numJobs) {
            Curry._1(setJobs, (function (oldJobs) {
                    return $$Array.sub(oldJobs, 0, numJobs);
                  }));
          } else if (numJobsInState < numJobs) {
            Curry._1(setJobs, (function (oldJobs) {
                    var jobsToAdd = Caml_array.caml_make_vect(numJobs - numJobsInState | 0, 1);
                    return $$Array.append(oldJobs, jobsToAdd);
                  }));
          }
          
        }), [
        numJobs,
        jobs
      ]);
  React.useEffect((function () {
          var startTime = performance.now();
          var newResult;
          switch (algo) {
            case /* Greedy */0 :
                newResult = LoadBalancing$AlgoVis.greedy(jobs, numMachines);
                break;
            case /* Ordered */1 :
                newResult = LoadBalancing$AlgoVis.ordered(jobs, numMachines);
                break;
            case /* PTAS */2 :
                newResult = LoadBalancing$AlgoVis.ptas(jobs, numMachines, epsilon);
                break;
            case /* BruteForce */3 :
                newResult = LoadBalancing$AlgoVis.bruteForce(jobs, numMachines);
                break;
            
          }
          Curry._1(setResult, (function (param) {
                  return newResult;
                }));
          var newMakespan = newResult !== undefined ? LoadBalancing$AlgoVis.getMakespan(newResult) : undefined;
          Curry._1(setMakespan, (function (param) {
                  return newMakespan;
                }));
          var endTime = performance.now();
          Curry._1(setRunningTime, (function (param) {
                  return endTime - startTime;
                }));
          
        }), [
        algo,
        jobs,
        numMachines,
        epsilon
      ]);
  return React.createElement("main", undefined, React.createElement("aside", undefined, React.createElement("form", {
                      className: "aside__scroll",
                      id: "input-form",
                      action: "#"
                    }, React.createElement("div", {
                          className: "aside__content",
                          role: "presentation"
                        }, React.createElement("div", {
                              "aria-labelledby": "algorithm-label",
                              className: "group",
                              role: "region"
                            }, React.createElement("label", {
                                  id: "algorithm-label",
                                  htmlFor: "algorithm"
                                }, "Algorithm"), React.createElement("div", {
                                  className: "algo-config"
                                }, React.createElement(Components$AlgoVis.Select.make, {
                                      children: null,
                                      id: "algorithm",
                                      value: LoadBalancing$AlgoVis.algoToString(algo),
                                      onChange: (function ($$event) {
                                          var newAlgo = LoadBalancing$AlgoVis.stringToAlgo($$event.target.value);
                                          if (newAlgo !== undefined) {
                                            return Curry._1(setAlgo, (function (param) {
                                                          return newAlgo;
                                                        }));
                                          }
                                          
                                        })
                                    }, React.createElement("option", {
                                          value: "greedy"
                                        }, "Greedy"), React.createElement("option", {
                                          value: "ordered"
                                        }, "Sorted Greedy"), React.createElement("option", {
                                          value: "ptas"
                                        }, "PTAS"), React.createElement("option", {
                                          value: "bruteForce"
                                        }, "Brute Force")), algo === /* PTAS */2 ? React.createElement("div", {
                                        className: "inline-input"
                                      }, React.createElement("label", {
                                            className: "inline-input__label",
                                            id: "epsilon-label",
                                            htmlFor: "epsilon"
                                          }, "ε ="), React.createElement(Components$AlgoVis.FloatNumberInput.make, {
                                            value: epsilon,
                                            id: "epsilon",
                                            min: 0.0,
                                            max: 1.0,
                                            step: 0.1,
                                            onChange: (function (newValue) {
                                                return Curry._1(setEpsilon, (function (param) {
                                                              return newValue;
                                                            }));
                                              })
                                          })) : null), React.createElement("div", {
                                  className: "group__bottom-text"
                                }, React.createElement("p", {
                                      className: "running-time",
                                      role: "note"
                                    }, "Running time: ", React.createElement("span", {
                                          dangerouslySetInnerHTML: {
                                            __html: LoadBalancing$AlgoVis.algoToRunningTime(algo)
                                          }
                                        })), React.createElement("p", {
                                      role: "note"
                                    }, "Approximation ratio: ", LoadBalancing$AlgoVis.algoToApproxRatio(algo)))), React.createElement("div", {
                              "aria-labelledby": "num-machines-label",
                              className: "group",
                              role: "region"
                            }, React.createElement("label", {
                                  id: "num-machines-label",
                                  htmlFor: "num-machines"
                                }, "Number of machines", React.createElement("span", {
                                      className: "lowercase"
                                    }, " (m)")), React.createElement(Components$AlgoVis.NumberInput.make, {
                                  value: numMachines,
                                  id: "num-machines",
                                  min: 1,
                                  max: 5,
                                  onChange: (function (newValue) {
                                      return Curry._1(setNumMachines, (function (param) {
                                                    return newValue;
                                                  }));
                                    })
                                })), React.createElement("div", {
                              "aria-labelledby": "num-jobs-label",
                              className: "group",
                              role: "region"
                            }, React.createElement("label", {
                                  id: "num-jobs-label",
                                  htmlFor: "num-jobs"
                                }, "Number of jobs", React.createElement("span", {
                                      className: "lowercase"
                                    }, " (n)")), React.createElement(Components$AlgoVis.NumberInput.make, {
                                  value: numJobs,
                                  id: "num-jobs",
                                  min: 1,
                                  max: 15,
                                  onChange: (function (newValue) {
                                      return Curry._1(setNumJobs, (function (param) {
                                                    return newValue;
                                                  }));
                                    })
                                })), React.createElement("div", {
                              "aria-labelledby": "job-inputs-label",
                              className: "group",
                              role: "region"
                            }, React.createElement("label", {
                                  id: "job-inputs-label",
                                  htmlFor: "job-input"
                                }, "Job sizes"), React.createElement("div", {
                                  className: "job-inputs"
                                }, React.createElement(Components$AlgoVis.MultiNumberInput.make, {
                                      value: jobs,
                                      id: "job-input",
                                      ariaLabelledby: "job-inputs-label",
                                      min: 1,
                                      max: 999,
                                      onChange: (function (newValue) {
                                          return Curry._1(setJobs, (function (param) {
                                                        return newValue;
                                                      }));
                                        })
                                    })))))), React.createElement("section", {
                  className: "tube tube--large"
                }, React.createElement(Components$AlgoVis.BarPlot.make, {
                      machines: match$5[0]
                    })), React.createElement("aside", undefined, React.createElement("div", {
                      className: "aside__scroll",
                      role: "presentation"
                    }, React.createElement("div", {
                          className: "aside__content",
                          role: "presentation"
                        }, React.createElement("div", {
                              "aria-labelledby": "result-label",
                              className: "group",
                              role: "region"
                            }, React.createElement("label", {
                                  id: "result-label",
                                  htmlFor: "result"
                                }, "Makespan"), React.createElement("output", {
                                  className: "result-number",
                                  id: "result",
                                  htmlFor: "input-form"
                                }, makespan !== undefined ? makespan : null), React.createElement("p", {
                                  role: "note"
                                }, runningTime !== undefined ? "Actual running time: " + Utils$AlgoVis.durationToString(runningTime) : null))))));
}

var Home = {
  make: Pages$Home
};

exports.Home = Home;
/* react Not a pure module */
